import { render, staticRenderFns } from "./permissionDialog.vue?vue&type=template&id=5ac15280&scoped=true"
import script from "./permissionDialog.vue?vue&type=script&lang=ts"
export * from "./permissionDialog.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./permissionDialog.vue?vue&type=style&index=0&id=5ac15280&prod&scoped=true&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5ac15280",
  "3984be0d"
  
)

export default component.exports